import { render, staticRenderFns } from "./FormTranUserPackageActivityReminderImport.vue?vue&type=template&id=ab7f21e6&scoped=true"
import script from "./FormTranUserPackageActivityReminderImport.vue?vue&type=script&lang=js"
export * from "./FormTranUserPackageActivityReminderImport.vue?vue&type=script&lang=js"
import style0 from "./FormTranUserPackageActivityReminderImport.vue?vue&type=style&index=0&id=ab7f21e6&prod&lang=scss&scoped=true"
import style1 from "./FormTranUserPackageActivityReminderImport.vue?vue&type=style&index=1&id=ab7f21e6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab7f21e6",
  null
  
)

export default component.exports